import { ThemeConfig } from '@webbyx/mui';

export const useThemeConfig = (): ThemeConfig => {
  const whiteColor = '#FFF';
  const lightColor = '76, 78, 100';
  const darkColor = '234, 234, 255';
  const accentColor = '#EC6C0C';
  const textBlue = '#3D5AFE';
  return {
    settings: {
      mode: 'light', // dark mode
      skin: 'bordered',
      contentWidth: 'boxed',
      footer: 'static',
      // ** Navigation (Menu) Configs
      navHidden: false,

      verticalNavToggleType: 'collapse',
      navCollapsed: false,
      horizontalMenuToggle: 'hover',

      // ** AppBar Configs
      appBar: 'fixed',
      appBarBlur: true,
    },
    // overriding theme with function
    overrides: (mode, skin) => ({
      palette: {
        customColors: {
          dark: darkColor,
          main: mode === 'light' ? lightColor : darkColor,
          mainDark: mode === 'light' ? darkColor : lightColor,
          light: lightColor,
          accent: accentColor,
          darkBg: '#282A42',
          lightBg: '#F7F7F9',
          bodyBg: mode === 'light' ? '#F7F7F9' : '#282A42', // Same as palette.background.default but doesn't consider bordered skin
          trackBg: mode === 'light' ? '#F2F2F4' : '#41435C',
          avatarBg: mode === 'light' ? '#F1F1F3' : '#3F425C',
          avatarText: mode === 'light' ? '#fff' : '#fff',
          tooltipBg: mode === 'light' ? '#262732' : '#464A65',
          tableHeaderBg: mode === 'light' ? '#F5F5F7' : '#3A3E5B',
          tableFooterBg: mode === 'light' ? '#E5E5E5' : '#36384e',
          tableFooterDisabled: mode === 'light' ? '#FFF0F0' : '#2f313d',
          tableErrorRow: mode === 'light' ? 'rgb(255, 240, 240)' : 'inherit',
          border: mode === 'light' ? '#E5E5E5' : `rgba(${darkColor}, 0.12)`,
          cardBg: mode === 'light' ? '#F5F6FA' : '#282A42',
          avatarBgLight: mode === 'light' ? '#FFE7D4' : '#563E41',
          textBlue,
        },
        primary: {
          light: mode === 'light' ? '#1B1B1B' : '#EC6C0C',
          main: mode === 'light' ? '#1B1B1B' : '#EC6C0C',
          // dark: '#5A5FE0',
          dark: mode === 'light' ? '#1B1B1B' : '#EC6C0C',
          contrastText: whiteColor,
        },
        secondary: {
          light: '#7F889B',
          main: mode === 'light' ? '#6D788D' : '#838CA4',
          dark: '#606A7C',
          contrastText: whiteColor,
        },
      },
      spacing: (factor: number) => {
        return `${0.2 * factor}rem`;
      },
      components: {
        MuiTableHead: {
          styleOverrides: {
            root: {
              '& .MuiTableCell-head': {
                background: '#EEEEEE !important',
                lineHeight: 1.5,
                textAlign: 'left'
              },
              '& .MuiTableCell-head::after': {
                background: '#A0A0A0 !important'
              },
            }
          }
        },
        MuiTypography: {
          variants: [
            {
              props: { variant: 'h5' },
              style: {
                fontWeight: '600',
                fontSize: 24,
              },
            },
            {
              props: { variant: 'h6' },
              style: {
                fontWeight: '600',
              },
            },
          ],
        },
        MuiTextField: {
          variants: [
            {
              props: { disabled: true },
              style: {
                background: '#F6F6F6',
                borderColor: '#E5E5E5',
                '& .MuiOutlinedInput-input': {
                  '-webkit-text-fill-color': mode === 'light' ? '#1B1B1B' : whiteColor
                }
              },
            }
          ]
        }
      },
    }),
    menuTextTruncate: true,
    enableSubItemIcon: true,
    // ** Other Configs
    responsiveFontSizes: false,
    disableRipple: false,
    enableCustomizer: false,
    enableLayoutLoader: true,
    layoutLoaderLasting: 1500,
    layoutLoaderAnimation: 'none',
  };
};
